// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout Styles - أنماط التخطيط */
.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  touch-action: pan-y;
}

.main-content {
  flex: 1;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Smooth scrolling for anchor links */
html {
  scroll-padding-top: 80px;
}

/* WhatsApp Floating Button - زر واتساب العائم */
.whatsapp-float {
  position: fixed;
  bottom: 30px;
  right: 30px;
  min-width: 60px;
  height: 60px;
  padding: 0 15px;
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  z-index: 9999;
  transition: all 0.3s ease;
  color: white;
  text-decoration: none;
  animation: pulse 2s infinite;
  font-weight: 600;
  visibility: visible;
  opacity: 1;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  border: none;
  outline: none;
}

.whatsapp-float:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 30px rgba(37, 211, 102, 0.6);
  background: linear-gradient(135deg, #128C7E 0%, #25D366 100%);
}

.whatsapp-float:active {
  transform: scale(0.95);
}

.whatsapp-icon {
  font-size: 1.8rem;
  line-height: 1;
  display: inline-block;
  vertical-align: middle;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}

.whatsapp-text {
  font-size: 0.9rem;
  white-space: nowrap;
  font-weight: 600;
}

/* Pulse Animation */
@keyframes pulse {
  0% {
    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  }
  50% {
    box-shadow: 0 4px 30px rgba(37, 211, 102, 0.7);
  }
  100% {
    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  }
}

/* Responsive - متجاوب */
@media (max-width: 768px) {
  .whatsapp-float {
    min-width: 55px;
    height: 55px;
    padding: 0 12px;
    bottom: 20px !important;
    right: 20px !important;
    left: auto !important;
  }

  .whatsapp-icon {
    font-size: 1.5rem;
  }

  .whatsapp-text {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .whatsapp-float {
    min-width: 50px;
    height: 50px;
    padding: 0 10px;
    bottom: 15px !important;
    right: 15px !important;
    left: auto !important;
  }

  .whatsapp-icon {
    font-size: 1.3rem;
  }

  .whatsapp-text {
    display: none; /* إخفاء النص على الشاشات الصغيرة */
  }
}

/* Pull to Refresh - السحب للتحديث */
.pull-to-refresh-indicator {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  z-index: 10000;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.refresh-spinner {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  animation: spin 1s linear infinite;
}

.refresh-text {
  font-size: 0.9rem;
  color: var(--primary-dark-blue);
  font-weight: 600;
  text-align: center;
}

.refreshing-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  pointer-events: none;
}

.refresh-spinner-large {
  font-size: 3rem;
  margin-bottom: 1rem;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/Layout.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,sCAAsC;AACtC;EACE,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,8CAA8C;EAC9C,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE;IACE,8CAA8C;EAChD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,8CAA8C;EAChD;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa,EAAE,mCAAmC;EACpD;AACF;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Layout Styles - أنماط التخطيط */\n.layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  touch-action: pan-y;\n}\n\n.main-content {\n  flex: 1;\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n/* Smooth scrolling for anchor links */\nhtml {\n  scroll-padding-top: 80px;\n}\n\n/* WhatsApp Floating Button - زر واتساب العائم */\n.whatsapp-float {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  min-width: 60px;\n  height: 60px;\n  padding: 0 15px;\n  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);\n  border-radius: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);\n  z-index: 9999;\n  transition: all 0.3s ease;\n  color: white;\n  text-decoration: none;\n  animation: pulse 2s infinite;\n  font-weight: 600;\n  visibility: visible;\n  opacity: 1;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  cursor: pointer;\n  border: none;\n  outline: none;\n}\n\n.whatsapp-float:hover {\n  transform: scale(1.1);\n  box-shadow: 0 6px 30px rgba(37, 211, 102, 0.6);\n  background: linear-gradient(135deg, #128C7E 0%, #25D366 100%);\n}\n\n.whatsapp-float:active {\n  transform: scale(0.95);\n}\n\n.whatsapp-icon {\n  font-size: 1.8rem;\n  line-height: 1;\n  display: inline-block;\n  vertical-align: middle;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n}\n\n.whatsapp-text {\n  font-size: 0.9rem;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n/* Pulse Animation */\n@keyframes pulse {\n  0% {\n    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);\n  }\n  50% {\n    box-shadow: 0 4px 30px rgba(37, 211, 102, 0.7);\n  }\n  100% {\n    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);\n  }\n}\n\n/* Responsive - متجاوب */\n@media (max-width: 768px) {\n  .whatsapp-float {\n    min-width: 55px;\n    height: 55px;\n    padding: 0 12px;\n    bottom: 20px !important;\n    right: 20px !important;\n    left: auto !important;\n  }\n\n  .whatsapp-icon {\n    font-size: 1.5rem;\n  }\n\n  .whatsapp-text {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .whatsapp-float {\n    min-width: 50px;\n    height: 50px;\n    padding: 0 10px;\n    bottom: 15px !important;\n    right: 15px !important;\n    left: auto !important;\n  }\n\n  .whatsapp-icon {\n    font-size: 1.3rem;\n  }\n\n  .whatsapp-text {\n    display: none; /* إخفاء النص على الشاشات الصغيرة */\n  }\n}\n\n/* Pull to Refresh - السحب للتحديث */\n.pull-to-refresh-indicator {\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  z-index: 10000;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n}\n\n.refresh-spinner {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n  animation: spin 1s linear infinite;\n}\n\n.refresh-text {\n  font-size: 0.9rem;\n  color: var(--primary-dark-blue);\n  font-weight: 600;\n  text-align: center;\n}\n\n.refreshing-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.95);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 10001;\n  pointer-events: none;\n}\n\n.refresh-spinner-large {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
